<template>
    <v-card elevation="0" style="overflow: hidden; border-radius: 8px">
        <v-card-title class="font14 py-1 greyText font-weight-regular">
            <v-icon>{{ icon }}</v-icon>
            {{ title }}
        </v-card-title>
        <v-card-text class="py-0 pt-3" style="overflow: auto" :style="'max-height: ' + tableHeight + 'px; min-height: ' + tableMinHeight + 'px'">
            <v-row v-for="(item, index) in betsTotal" :key="index" class="px-1" style="height: 66px">
                <v-card width="100%" class="my-1" elevation="1" :style="$vuetify.theme.dark ? 'background-color: #323338!important' : ''">
                    <v-card-text class="pl-2 py-2 font12">
                        <v-row class="pt-1 pl-7">
                            <v-spacer></v-spacer>
                            {{ item.created_at | formatInTimeZone('dd MMM HH:mm:ss', true) }}
                        </v-row>
                        <v-row :class="$vuetify.theme.dark ? 'whiteText' : 'black--text'">
                            <v-col style="min-width: 25px; max-width: 25px" class="text-center pl-2 pr-0 pt-0 pb-2">
                                <span class="text-center">
                                    <span v-if="item.betOrderId">
                                        <v-tooltip
                                            :disabled="utils.isMobile()"
                                            :color="$vuetify.theme.dark ? '#5F6673' : '#9e9e9e'"
                                            open-delay="500"
                                            bottom
                                            :open-on-focus="false"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-bind="attrs" v-on="on" class="" color="grey" small dense size="9">mdi-clipboard-clock-outline</v-icon>
                                            </template>
                                            {{ $t('bet.orderIcon') }}
                                        </v-tooltip>
                                    </span>

                                    <span v-else>
                                        <v-tooltip
                                            :disabled="utils.isMobile()"
                                            :color="$vuetify.theme.dark ? '#5F6673' : '#9e9e9e'"
                                            open-delay="500"
                                            bottom
                                            :open-on-focus="false"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-bind="attrs" v-on="on" class="" color="grey" small dense size="9">mdi-robot-outline</v-icon>
                                            </template>
                                            {{ $t('bet.botIcon') }}
                                        </v-tooltip>
                                    </span>
                                    <br />

                                    <v-tooltip
                                        :disabled="utils.isMobile()"
                                        :color="$vuetify.theme.dark ? '#5F6673' : '#9e9e9e'"
                                        open-delay="500"
                                        bottom
                                        :open-on-focus="false"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon
                                                v-bind="attrs"
                                                v-on="on"
                                                class=""
                                                :style="
                                                    item.status_id === $const.BET_STATUS_RUN
                                                        ? 'color: #38761d !important'
                                                        : item.status_id === $const.BET_STATUS_WAIT
                                                        ? 'color: #ff9900 !important'
                                                        : item.status_id === $const.BET_STATUS_REJ
                                                        ? 'color: rgba(173,10,10,0.85) !important'
                                                        : ''
                                                "
                                                size="11"
                                            >
                                                mdi-circle
                                            </v-icon>
                                        </template>
                                        <span v-if="item.status_id === $const.BET_STATUS_RUN">
                                            {{ $t('bet.statusRunning') }}
                                        </span>
                                        <span v-if="item.status_id === $const.BET_STATUS_WAIT">
                                            {{ $t('bet.statusWaiting') }}
                                        </span>
                                        <span v-if="item.status_id === $const.BET_STATUS_REJ">
                                            {{ $t('bet.statusRejected') }}
                                        </span>
                                    </v-tooltip>
                                </span>
                            </v-col>
                            <v-col class="pl-1 pr-0 pt-0 pb-2">
                                <div
                                    data-tooltip-position="left"
                                    :class="
                                        item.status_id === $const.BET_STATUS_WAIT
                                            ? 'waiting'
                                            : item.status_id === $const.BET_STATUS_REJ
                                            ? 'text-decoration-line-through'
                                            : ''
                                    "
                                    v-html="getGameName(item)"
                                ></div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<style scoped></style>

<script>
    import AppEventStatsRow from 'Pages/core/event/EventStatsRow.vue';
    import utils from 'Helpers/utils';

    export default {
        name: 'app-eventBetsSidePanel',
        components: { AppEventStatsRow },
        props: {
            title: {
                default: undefined,
                type: String,
            },
            icon: {
                default: undefined,
                type: String,
            },
            tableHeight: {
                default: undefined,
                type: Number,
            },
            tableFullHeight: {
                default: undefined,
                type: Number,
            },
            betsTotal: {
                default: undefined,
                type: Array,
            },
            betsTotalSettled: {
                default: undefined,
                type: Array,
            },
            orders: {
                default: undefined,
                type: Array,
            },
        },
        watch: {},
        mounted() {
            console.log('Component %s mounted.', this.$options.name);
        },
        data() {
            return {};
        },

        methods: {
            isEmpty(value) {
                return _.isEmpty(value);
            },
            getGameName(item) {
                let info = utils.bettingInfoForMessage(item, true, 'float-end', true, false);
                return info.gameInfo + '<br>' + info.betInfo;
            },
        },
        computed: {
            event() {
                return this.$store.getters['EventModule/getEvent'];
            },

            eventStats() {
                return this.$store.getters['EventModule/getStats'];
            },

            user() {
                return this.$store.getters['UserModule/getUser'];
            },

            tableMinHeight() {
                const maxMinHeight = this.tableFullHeight - 94 - 16 - 34; // - position,margin and header

                let height = this.betsTotal.length * 66 + 4; //4 - extra margin bottom
                height = height > maxMinHeight ? maxMinHeight : height;

                return this.tableHeight > height ? height : this.tableHeight;
            },
        },
    };
</script>
